/**
 * External dependencies
 */
import React from 'react';
// import { ALLOWED_STATES } from '@woocommerce/block-settings';
import { ALLOWED_STATES } from '../../../settings/blocks';
/**
 * Internal dependencies
 */
import StateInput from './state-input';
import type { StateInputProps } from './StateInputProps';

const BillingStateInput = ( props: StateInputProps ): JSX.Element => {
	return <StateInput states={ ALLOWED_STATES } { ...props } />;
};

export default BillingStateInput;
